import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/Services/api.service';
import { ModalBaseComponent } from 'src/app/shared/modals/modal-base/modal-base.component';

@Component({
    selector: 'app-edit-citation-exemption-list-entry',
    templateUrl: './edit-citation-exemption-list-entry.component.html',
    styleUrls: ['./edit-citation-exemption-list-entry.component.scss'],
    standalone: false
})
export class EditCitationExemptionListEntryComponent extends ModalBaseComponent<any, any> implements OnInit {

  public Model: any = {};
  public ListId!: number;
  public Form!: UntypedFormGroup;
  public Saving: boolean = false;

  constructor(private apiService: ApiService, private toastr: ToastrService) {
    super();
  }

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      PlateNumber: new UntypedFormControl(this.Model?.PlateNumber ?? '', [Validators.required, Validators.minLength(1), Validators.maxLength(12)]),
      RegionCode: new UntypedFormControl(this.Model?.RegionCode ?? '', [Validators.maxLength(100)]),
      ExpiresOnLocal: new UntypedFormControl(
        this.Model?.ExpiresOnLocal
          ? this.Model.ExpiresOnLocal.toString().split('T')[0]
          : null
      ),
      Notes: new UntypedFormControl(this.Model?.Notes ?? '', [Validators.maxLength(1024)]),
    });
  }

  public get IsNew(): boolean {
    return !this.Model?.Id;
  }

  public async Save(): Promise<void> {
    if (!this.Form.valid) return;
    this.Saving = true;
    const body = this.Form.getRawValue();
    try {
      let saved: any;
      if (this.IsNew) {
        saved = await this.apiService.Post(
          `enforcement/citation-exemption-lists/${this.ListId}/entries`, body);
      } else {
        saved = await this.apiService.Put(
          `enforcement/citation-exemption-lists/${this.ListId}/entries/${this.Model.Id}`, body);
      }
      this.result = saved;
      super.confirm();
    } catch (err: any) {
      this.toastr.error(err?.error?.Error?.Message ?? 'An error occurred', 'Error');
    } finally {
      this.Saving = false;
    }
  }

  public Cancel(): void {
    this.result = null;
    super.confirm();
  }
}
